import classNames from 'classnames';
import Styles from './WorklistDashboardTicker.module.scss';
import { Link } from 'react-router';
import { DobTooltip } from '@dedalusdiit/dob-components';

const {
    abbreviation: abbreviationStyle,
    count: countStyle,
    ticker: tickerStyle,
    tickerThresholdNone: tickerThresholdNoneStyle,
    tickerThresholdMedium: tickerThresholdMediumStyle,
    tickerThresholdHigh: tickerThresholdHighStyle,
} = Styles;

export interface IWorklistDashboardTickerProps {
    abbreviation: string;
    highThreshold: number;
    mediumThreshold: number;
    resultCount: number;
    resultCountOverflow: boolean;
    worklistDescription?: string;
    worklistID: number;
    worklistName: string;
}

const WorklistDashboardTicker = (props: IWorklistDashboardTickerProps): React.ReactElement => {
    const { abbreviation, highThreshold: hightThreshold, mediumThreshold, resultCount, resultCountOverflow, worklistDescription, worklistID, worklistName } = props;

    const thresholdLevel = getThresholdLevelOfTicker(resultCount, mediumThreshold, hightThreshold);

    const worklistURL = `/Worklist?id=${worklistID}`;

    const atNoneThreshold = thresholdLevel === 'none';
    const atMediumThreshold = thresholdLevel === 'medium';
    const atHighThreshold = thresholdLevel === 'high';
    const tickerClassNames = classNames(tickerStyle, {
        [tickerThresholdNoneStyle]: atNoneThreshold,
        [tickerThresholdMediumStyle]: atMediumThreshold,
        [tickerThresholdHighStyle]: atHighThreshold,
    });

    const resultCountOverflowIndicator = resultCountOverflow ? '+' : '';

    const tooltip = (<WorklistDashboardTickerTooltip abbreviation={abbreviation} worklistName={worklistName} worklistDescription={worklistDescription} />);

    return (
        <Link to={worklistURL}>
            <DobTooltip content={tooltip}>
                <div className={tickerClassNames}>
                    <span className={abbreviationStyle}>{abbreviation}</span>
                    <span className={countStyle}>{`${resultCount}${resultCountOverflowIndicator}`}</span>
                </div>
            </DobTooltip>
        </Link>
    );
};

const WorklistDashboardTickerTooltip = (props: { abbreviation: string; worklistDescription?: string; worklistName: string }): React.ReactElement => {
    const { abbreviation, worklistDescription, worklistName } = props;

    return (
        <div>
            <h4>
                {worklistName}&nbsp;(<b>{abbreviation}</b>)
            </h4>
            <p>
                <i>{worklistDescription ?? ''}</i>
            </p>
        </div>
    );
};

const getThresholdLevelOfTicker = (count: number, mediumThreshold: number, highThreshold: number): 'none' | 'medium' | 'high' | undefined => {
    if (count === 0) {
        return 'none';
    }
    if (count > highThreshold) {
        return 'high';
    }
    if (count > mediumThreshold) {
        return 'medium';
    }
    return undefined;
};

export default WorklistDashboardTicker;
